import { Drawer } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import {
  GUEST_ROOM_EXPERIENCE_TEMPLATE_ADD_ROOM,
  GUEST_ROOM_EXPERIENCE_TEMPLATE_CREATE,
  GUEST_ROOM_EXPERIENCE_TEMPLATE_EDIT,
} from '../../../../../../constants/GuestRoomExperienceConst';
import { selectedHotelSelector } from '../../../../../property/propertySlice';
import { fetchGRETemplates, fetchVendors } from '../../../../configurationSlice';
import GuestRoomExperienceTemplateCreate from './template-create/Template-Create';
import GuestRoomExperienceTemplateList from './template-list/Template-List';
import GuestRoomExperienceTemplateRooms from './template-rooms/Template-Rooms';

const GuestRoomExperienceTemplate = (props) => {
  const { onViewToggleTemplate, showLoader = () => {} } = props;
  const [state, setState] = useState({
    type: GUEST_ROOM_EXPERIENCE_TEMPLATE_CREATE,
    status: false,
  });
  const selectedHotel = useSelector(selectedHotelSelector);
  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedHotel) {
      dispatch(fetchGRETemplates(selectedHotel));
      dispatch(fetchVendors(selectedHotel));
    }
  }, [selectedHotel, dispatch]);

  const onDrawerToggle = (type, status, obj) => {
    setState({ type: type, status: status, obj: obj });
  };

  const toggleDrawer = (open) => (event, reason) => {
    if (
      reason === 'backdropClick' ||
      (event?.type === 'keydown' && (event?.key === 'Tab' || event?.key === 'Shift'))
    ) {
      return;
    }
    setState(open);
  };

  const switchDrawerContent = (state) => {
    switch (state.type) {
      case GUEST_ROOM_EXPERIENCE_TEMPLATE_CREATE:
        return (
          <GuestRoomExperienceTemplateCreate
            toggleDrawer={onDrawerToggle}
            showLoader={showLoader}
            hotelId={selectedHotel}
            onDrawerToggle={onDrawerToggle}
          />
        );
      case GUEST_ROOM_EXPERIENCE_TEMPLATE_EDIT:
        return (
          <GuestRoomExperienceTemplateCreate
            toggleDrawer={onDrawerToggle}
            template={state.obj}
            showLoader={showLoader}
            hotelId={selectedHotel}
            onDrawerToggle={onDrawerToggle}
          />
        );
      case GUEST_ROOM_EXPERIENCE_TEMPLATE_ADD_ROOM:
        return (
          <GuestRoomExperienceTemplateRooms
            toggleDrawer={onDrawerToggle}
            showLoader={showLoader}
            template={state.obj}
            hotelId={selectedHotel}
            onDrawerToggle={onDrawerToggle}
          />
        );
      default:
        break;
    }
  };

  return (
    <div>
      <Drawer
        anchor={'right'}
        open={state.status}
        onClose={toggleDrawer(false)}
        className='right-drawer'
      >
        {switchDrawerContent(state)}
      </Drawer>
      <GuestRoomExperienceTemplateList
        onDrawerToggle={onDrawerToggle}
        selectedHotel={selectedHotel}
        state={state}
        onViewToggleTemplate={onViewToggleTemplate}
      />
    </div>
  );
};

export default GuestRoomExperienceTemplate;
